import { createSubscription, getActiveSubscriptions, updateSubscription } from '../../api/admin';
import invalidationManager from './InvalidationManager';

const { hook: useSubscriptions } = invalidationManager.createFetcher({
  queryKey: (companyId: string) => ['company', companyId, 'subscriptions'],
  fetchFunction: async (companyId: string) => {
    return getActiveSubscriptions(companyId);
  },
});

const useCreateSubscriptionMutation = invalidationManager.createMutationHook({
  mutationFunction: async (
    companyId: string,
    subscriptionData: {
      subscriptionId: string;
      startDate: string;
      endDate?: string;
    },
  ) => {
    await createSubscription(companyId, subscriptionData);
    await invalidationManager.invalidate(['company', companyId, 'subscriptions']);
    await invalidationManager.invalidate(['company', companyId, 'billingItems']);
  },
});

const useUpdateSubscriptionMutation = invalidationManager.createMutationHook({
  mutationFunction: async (
    companyId: string,
    subscriptionId: string,
    subscriptionData: {
      endDate?: string;
    },
  ) => {
    await updateSubscription(companyId, subscriptionId, subscriptionData);
    await invalidationManager.invalidate(['company', companyId, 'subscriptions']);
    await invalidationManager.invalidate(['company', companyId, 'billingItems']);
  },
});

export { useCreateSubscriptionMutation, useSubscriptions, useUpdateSubscriptionMutation };
